import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import OutlinedPageBox from '../global/OutlinedPageBox';
import CenteredContentLayout from '../global/CenteredContentLayout';
import useBusiness from '../../hooks/businesses/useBusiness';
import { getShopFlashbookUrl } from '../../helpers/flashbooks';

interface Props {
  onAdd: () => void;
  onOpenSettings?: () => void;
}

export default function FlashbookEmptyState({ onAdd, onOpenSettings }: Props) {
  const { business } = useBusiness();
  const url = getShopFlashbookUrl(business);

  return (
    <OutlinedPageBox>
      <CenteredContentLayout
        image={BoltOutlinedIcon}
        title="Your flashbook is empty!"
        description="Add a flash design so clients can browse and book it directly from your storefront."
        button={{
          text: 'Add new',
          onClick: onAdd,
        }}
        secondaryButton={
          onOpenSettings
            ? {
                icon: SettingsOutlinedIcon,
                text: 'Flashbook Settings',
                onClick: onOpenSettings,
              }
            : undefined
        }
        maxWidth="750px"
        imageMaxWidth="120px"
        copyContent={url || undefined}
      />
    </OutlinedPageBox>
  );
}
